import { Cell, CellGroup, Step, Steps, Button, Popup } from 'vant'
import Bussiness from 'Utils/business'
import { getSysType } from '@/common/utils/plus'
import ldUploader from 'Components/ldUploader'
import ldEmailPopup from 'Components/LdEmailPopup'

export default {
  name:'HtRefundDetail',
  provide: {
    orderType: $dict.ORDER_TYPE.hotel.refund
  },
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Popup.name]: Popup,
    [Button.name]: Button,
    approval: () => import('Components/approval/approval'),
    ldTabbar: () => import('Components/ldTabbar/ldTabbar'),
    Bussiness,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldButton: () => import('Common/ldButton'),
    ldUploader,
    ldEmailPopup
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      mescroll: null, // mescroll实例对象
      path: '',
      data_: {},
      progressList: [
        { index: '0', value: '申请已提交'	},
        { index: '1', value: '送审'},
        { index: '2', value: '办理退订中'},
        { index: '3', value: '退订办理完成'},
        { index: '4', value: '退款'}
      ],
      progressList_: [],
      mescrollDown: {
        callback: this.loadData,
      },
    }
  },
  mounted() {
    /**
     * 初始化数据
     */
    this.loadData()
  },
  created() { },
  methods: {
    mescrollInit (mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    loadData() {
      this.$api['htQuery/hotelRefundDetail']({
        hotelRefundId: this.id
      }).then(res => {
        this.data_ = res.data
        this.progressList_ = JSON.parse(JSON.stringify(this.progressList))
        !this.data_.spzgId && this.progressList_.splice(1, 1)
        this.$nextTick(() => { // 数据渲染成功后,隐藏下拉刷新的状态
          this.mescroll.endSuccess()
        })
      }).catch(() => {})
    },
    /**
     * 取消
     */
    cancel() {
      this.$dialog.confirm({
        message:'是否取消订单'
      }).then(() => {
        this.$api['htQuery/hotelRefundCancel']({
          orderFrom: getSysType(),
          hotelRefundId: this.data_.htRefundId
        }).then(()=>{
          this.loadData()
        })
      })
    },
    /**
     * 送审/再次送审
     */
    approval() {
      this.data_.orderType = '11008'
      /**
       * 退单详情返回退单orderNo
       */
      let items = JSON.parse(JSON.stringify(this.data_))
      items.orderNo = items.refundNo
      items.orderId = items.htRefundId
      Bussiness.ApprovalSend(items)
    },
    async revertApproval () {
      await Bussiness.ApprovalSend({
        orderId: this.data_.htRefundId,
        orderType: '11008'
      })
      this.loadData()
    }
  },
  watch: {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name == 'htRefundComplete') {
        vm.path = '/allorder?findType=1'
      }
    })
  }
}
